import { DEFAULT_VALUE_IF_NIL } from '@clearverify/constants';
export const parseNullableValue = (value, valueIfNil = DEFAULT_VALUE_IF_NIL) => {
    if (!String(value).length) {
        return valueIfNil;
    }
    return value ?? valueIfNil;
};
//# sourceMappingURL=helpers.js.map